import React from 'react';
import { type IOptions } from '../../../utils/options';
import { IOptionProps } from '../_props';

type LabelProps = {
  highlightOptions: IOptionProps['highlightOptions'];
  inputValue: IOptionProps['inputValue'];
  highlightIndexes: number[];
  index: number;
  option: IOptions;
  optionHighlightedTextThemeClasses: string;
};

export default function Label({
  highlightOptions,
  inputValue,
  highlightIndexes,
  index,
  option,
  optionHighlightedTextThemeClasses,
}: LabelProps) {
  return (
    <span className="flex-1">
      {highlightOptions && inputValue && highlightIndexes[index] >= 0 ? (
        <>
          {option.label.substring(0, highlightIndexes[index])}
          <span className={optionHighlightedTextThemeClasses}>
            {option.label.substring(highlightIndexes[index], highlightIndexes[index] + inputValue.length)}
          </span>

          {option.label.substring(inputValue.length + highlightIndexes[index])}
        </>
      ) : (
        option.label
      )}
    </span>
  );
}
